import { Box, Button, CloseButton, Flex, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { getDeploymentIdentifier, hasDeploymentChanged } from '../../utils/deploymentVersion';

/**
 * Component that shows a notification when a deployment has occurred
 * This helps users understand why they might need to refresh or re-authenticate
 */
export const DeploymentNotification: React.FC = () => {
  const [showNotification, setShowNotification] = useState(false);
  const [deploymentInfo, setDeploymentInfo] = useState('');

  useEffect(() => {
    // Check if a deployment has occurred
    if (hasDeploymentChanged()) {
      setShowNotification(true);
      setDeploymentInfo(getDeploymentIdentifier());
    }
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleClose = () => {
    setShowNotification(false);
  };

  if (!showNotification) {
    return null;
  }

  return (
    <Box
      position="fixed"
      top="1rem"
      right="1rem"
      bg="blue.500"
      color="white"
      p="1rem"
      borderRadius="0.5rem"
      boxShadow="0 4px 6px rgba(0, 0, 0, 0.1)"
      zIndex={1000}
      maxW="20rem"
    >
      <Flex justify="space-between" align="start" mb="0.5rem">
        <Text fontWeight="bold" fontSize="0.875rem">
          Application Updated
        </Text>
        <CloseButton size="sm" onClick={handleClose} />
      </Flex>

      <Text fontSize="0.75rem" mb="1rem">
        {deploymentInfo}. You may need to refresh the page for the latest changes.
      </Text>

      <Flex gap="0.5rem">
        <Button
          size="sm"
          variant="outline"
          color="white"
          borderColor="white"
          _hover={{ bg: 'white', color: 'blue.500' }}
          onClick={handleRefresh}
        >
          Refresh Now
        </Button>
        <Button
          size="sm"
          variant="ghost"
          color="white"
          _hover={{ bg: 'whiteAlpha.200' }}
          onClick={handleClose}
        >
          Dismiss
        </Button>
      </Flex>
    </Box>
  );
};
